import { INVESTOR } from '../types';

const initialState = {
  investor: {},
  investors: [],
};

const investorReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVESTOR.SET_INVESTOR:
      return {
        investor: action.investor,
      };

    case INVESTOR.SET_INVESTORS:
      return {
        investors: action.investors,
      };

    default:
      return state;
  }
};

export default investorReducer;